import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroBanner from "./components/HeroBanner";
import CategoryEntry from "./components/CategoryEntry";
import FeaturedGrid from "./components/FeaturedGrid";
import NewsTicker from "./components/NewsTicker";
import SiteIntro from "./components/SiteIntro";
import { videos } from "@/mocks/videos";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function Home() {
  useDocumentMeta({
    title: "日皮视频-最新影视资讯与精彩视频内容平台",
    description:
      "日皮视频为您提供丰富多样的视频内容，包括影视资讯、短视频以及热门视频推荐，满足您的多样观影需求。",
    keywords:
      "日皮视频,视频内容,影视资讯,热门视频,短视频,高清视频,视频平台",
  });

  const main =
    videos.find((v) => v.featured && v.category === "hot-video") ?? videos[0];
  const side = [...videos]
    .sort((a, b) => b.views - a.views)
    .filter((v) => v.id !== main.id)
    .slice(0, 5);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <h1 className="sr-only">日皮视频</h1>
        <HeroBanner main={main} side={side} />
        <CategoryEntry />
        <FeaturedGrid />
        <NewsTicker />
        <SiteIntro />
      </main>
      <Footer />
    </div>
  );
}